import { ROUTE_ENUM } from "enums";
import { useNavigate } from "react-router";

const useGoBackOrHome = () => {
  const navigate = useNavigate();

  return () => {
    const historyIndex = (window.history.state as { idx?: number } | null)
      ?.idx;

    if (typeof historyIndex === "number" && historyIndex > 0) {
      navigate(-1);
    } else {
      navigate(ROUTE_ENUM.HOME);
    }
  };
};

export default useGoBackOrHome;
